import { defineComponent as _defineComponent } from 'vue'
import { UseCase } from '@/ui/microtrend/use-cases/use-cases.types'
import { ref, watch } from 'vue'
import { SavedUseCasesTextContent } from '@/ui/microtrend/use-cases/saved-use-cases/saved-use-cases.types'
import ButtonWithConfirmationDialog from '@/ui/button-with-confirmation-dialog/button-with-confirmation-dialog.vue'

interface Props {
  useCases: UseCase[]
  activeUseCaseId?: string
  textContent: SavedUseCasesTextContent
  deleteUseCase: (useCase: UseCase) => Promise<void>
  editUseCase: (useCase: UseCase) => Promise<void>
}


export default /*#__PURE__*/_defineComponent({
  __name: 'saved-use-cases',
  props: {
    useCases: null,
    activeUseCaseId: null,
    textContent: null,
    deleteUseCase: null,
    editUseCase: null
  },
  setup(__props: any) {

const props = __props as { useCases: UseCase[], activeUseCaseId?: string, textContent: SavedUseCasesTextContent, deleteUseCase: (useCase: UseCase) => Promise<void>, editUseCase: (useCase: UseCase) => Promise<void> }

const activePanel = ref<number | null>(null)



const deleteInProgress = ref<boolean>(false)

async function handleDeleteUseCase (useCase: UseCase): Promise<void> {
    deleteInProgress.value = true
    try {
        await props.deleteUseCase(useCase)
    } catch (e) {
        console.log('%cUse case deletion failed', 'color: red;')
    } finally {
        deleteInProgress.value = false
    }
}

watch(
    () => props.activeUseCaseId,
    (newValue) => {
        activePanel.value = props.useCases.findIndex(useCase => useCase.id === newValue)
    },
    { immediate: true }
)

return { __sfc: true,activePanel, props, deleteInProgress, handleDeleteUseCase, ButtonWithConfirmationDialog }
}

})